import { render, staticRenderFns } from "./tasting.vue?vue&type=template&id=23b3ca9a"
import script from "./tasting.vue?vue&type=script&lang=js"
export * from "./tasting.vue?vue&type=script&lang=js"
import style0 from "./tasting.vue?vue&type=style&index=0&id=23b3ca9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports